<template>
<v-content>
  <v-overlay>
    <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
  </v-overlay>
</v-content>
</template>

<script>
export default {
  data() {
    return {
      init: null,
    };
  },
  async mounted() {
    var business_service_req = {
      params: {
        'sid': this.storageGet('sid')
      }}
    var business_service_res = await this.apiCall('/business-service/get-info', business_service_req )
    if (!business_service_res.data) return false;
    this.init = this.storageGet("*");
    const moplink = "https://" + process.env.VUE_APP_HOST_NAME + "/mop/shop-list?sid="+this.init.sid+"&os="+this.init.os+"&device_id="+this.init.device_id+"&key="+this.init.key+"&registration_id="+this.init.registration_id+"&app_version="+this.init.app_version+"&feature_id=1&device_uid="+this.init.device_uid+"&business_code="+business_service_res.data.business_code

    location.replace(moplink)
  }
}
</script>
